type Listener = () => void;

const listeners = new Set<Listener>();

export const notifyChangesSaved = (): void => {
  for (const listener of listeners) listener();
};

export const onChangesSaved = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
